"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AraasRemoteDataTrack = exports.RemoteDataTrack = exports.AraasLocalDataTrack = void 0;
const events_1 = require("events");
const operators_1 = require("rxjs/operators");
const rxjs_1 = require("rxjs");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const logger_1 = require("../../util/logger");
class AraasLocalDataTrack {
    constructor(config) {
        this.config = config;
        this.kind = 'dataTrack';
    }
    send(message) {
        return __awaiter(this, void 0, void 0, function* () {
            this.config.sendMessage(streem_sdk_protobuf_1.streem.room.DataTrackMessage.encode(message).finish());
        });
    }
}
exports.AraasLocalDataTrack = AraasLocalDataTrack;
class RemoteDataTrack extends events_1.EventEmitter {
    emitMessage(message) {
        if (typeof message === 'string' && message.length) {
            this.emit('message', message);
        }
        else if (typeof message !== 'string' && message.byteLength) {
            this.emit('message', message);
        }
    }
}
exports.RemoteDataTrack = RemoteDataTrack;
class AraasRemoteDataTrack {
    constructor(eventTrack) {
        this.kind = 'dataTrack';
        const messages = new rxjs_1.Observable(subscriber => {
            eventTrack.on('message', (data) => {
                try {
                    if (typeof data !== 'string') {
                        subscriber.next(streem_sdk_protobuf_1.streem.room.DataTrackMessage.decode(new Uint8Array(data)));
                    }
                }
                catch (error) {
                    logger_1.logger.debug('Failed to decode message', data, error);
                }
            });
            subscriber.add(() => {
                eventTrack.removeAllListeners();
            });
        });
        // It is essential that messages is a hot observable. All subscribers
        // to messages must get data from this producer.
        // - Alex
        this.messages = messages.pipe((0, operators_1.share)());
    }
}
exports.AraasRemoteDataTrack = AraasRemoteDataTrack;
//# sourceMappingURL=data_tracks.js.map